import createApiServices from "./createApiServices"
import {BACKEND_URL} from "../ConfigUrlApi"

const api = createApiServices({baseUrl: BACKEND_URL})

const serialiseObject = function(obj) {
    let pairs = [];
    for (let prop in obj) {
        if (!obj.hasOwnProperty(prop)) {
            continue;
        }
        if (Object.prototype.toString.call(obj[prop]) === '[object Object]') {
            pairs.push(serialiseObject(obj[prop]));
            continue;
        }
        pairs.push(prop + '=' + obj[prop]);
    }
    return pairs.join('&');
}

export const deleteContactList = (userName, payload) => {
    return api.makeRequestQueue({
        url: `/crm/deleteContactListCPO?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const getUserProfileV1 = (username, payload) =>{
    return api.makeRequestQueue({
        url: `/v1.0/base/getUserProfileV1?userName=${username}`,
        method: 'POST',
        data: payload
    })
}

export const updateUserProfileV1 = (username, payload) =>{
    return api.makeRequestQueue({
        url: `/agent/updateUserSetting?userName=${username}&type=FOLLOW_ME`,
        method: 'POST',
        data: payload
    })
}

export const getRoleDataLevel = (payload) => {
    const param = serialiseObject(payload)
    return api.makeRequestQueue({
        url: `/setting/role/data-level?${param}`,
        method: 'GET'
    })
}

export const getRoleObject = (payload) => {
    const param = serialiseObject(payload)
    return api.makeRequestQueue({
        url: `/setting/role/object?${param}`,
        method: 'GET'
    })
}

export const saveRoleDataLevel = (username, payload) => {
    return api.makeRequestQueue({
        url: `/setting/role/data-level?userName=${username}`,
        method: 'POST',
        data: payload
    })
}

export const saveRoleObject = (username, payload) => {
    return api.makeRequestQueue({
        url: `/setting/role/object?userName=${username}`,
        method: 'POST',
        data: payload
    })
}
